/**
 * 펫리듬 — 사용자 노출 문구 카탈로그 (SSOT)
 *
 * 규칙 (docs/12-ui-spec.md §7, docs/14-legal-policy-drafts.md §2):
 *  1. 화면에 보이는 모든 텍스트는 여기에 있어야 한다. 컴포넌트 안 리터럴 문자열은 lint로 차단한다.
 *  2. 어조: 조용한 · 단단한 · 곁의. 존대. 감탄사·이모지·느낌표 금지. 축하하지 않는다.
 *  3. 판정 금지: 진단·정상/비정상·위험·악화·호전·치료·처방·"병원에 가세요"를 쓰지 않는다.
 *     허용: 사실 서술("최근 7일 평균 24회"), 주치의로의 위임("주치의와 상의해 보세요").
 *  4. 놓친 것을 지적하지 않는다. 독촉 문구를 만들지 않는다.
 *  5. {변수}는 런타임 치환. 숫자 포맷은 호출부가 담당한다.
 *
 * 검사: scripts/check-copy.mjs — 금지 표현 fixture + 스냅샷 (체크리스트 A5·A6)
 */
export const ko = {
    // ─── 공통 ──────────────────────────────────────────────
    'common.appName': '펫리듬',
    'common.loading': '불러오는 중이에요.',
    'common.offline': '지금은 오프라인이에요. 기록은 기기에 저장되고 있어요.',
    'common.saved': '기록했어요.',
    'common.undo': '되돌리기',
    'common.retry': '다시 시도',
    'common.cancel': '취소',
    'common.confirm': '확인',
    'common.save': '저장',
    'common.delete': '삭제',
    'common.edit': '수정',
    'common.close': '닫기',
    'common.back': '뒤로',
    'common.next': '다음',
    'common.skip': '건너뛰기',
    'common.later': '나중에',
    'common.noRecord': '기록 없음',
    'common.today': '오늘',
    'common.optional': '선택',
    'common.required': '필수',
    // ─── 에러 ──────────────────────────────────────────────
    // 5xx·네트워크 실패 문구에는 반드시 "기록은 기기에" 안심 문장을 포함한다 (15 §4)
    'error.save': '저장하지 못했어요. 다시 시도할까요?',
    'error.network': '지금은 연결이 어려워요. 기록은 기기에 저장돼 있어요.',
    'error.internal': '문제가 생겼어요. 기록은 안전해요.',
    'error.validation': '입력을 다시 확인해 주세요.',
    'error.unauthorized': '다시 연결할게요.',
    'error.forbidden': '권한이 없어요.',
    'error.notFound': '찾을 수 없어요.',
    'error.rateLimited': '잠시 후 다시 시도해 주세요.',
    'error.checkValue': '값을 다시 확인해 주세요.',
    'error.loadFailed': '불러오지 못했어요.',
    // ─── 온보딩 ────────────────────────────────────────────
    'onboarding.hero': '아이의 오늘을 남겨두면, 진료실에서 3개월을 이야기할 수 있어요.',
    'onboarding.startCta': '시작하기',
    'onboarding.noSignup': '가입 없이 바로 쓸 수 있어요.',
    // ─── 반려동물 (F1) ─────────────────────────────────────
    'pet.new': '아이 등록',
    'pet.name': '이름',
    'pet.namePlaceholder': '아이 이름',
    'pet.species': '종류',
    'pet.speciesDog': '개',
    'pet.speciesCat': '고양이',
    'pet.breed': '품종',
    'pet.birthDate': '생년월일',
    'pet.birthYearOnly': '태어난 해만 알아요',
    'pet.sex': '성별',
    'pet.sexMale': '수컷',
    'pet.sexFemale': '암컷',
    'pet.sexUnknown': '모르겠어요',
    'pet.neutered': '중성화했어요',
    'pet.conditions': '진단받은 질환',
    'pet.conditionsHint': '고르면 그 질환에 맞는 기록 항목을 보여드려요. 나중에 바꿀 수 있어요.',
    'pet.vetNote': '주치의·병원 메모',
    'pet.created': '{name}를 등록했어요.',
    'pet.ageYearsMonths': '{years}년 {months}개월',
    'pet.ageMonths': '{months}개월',
    'pet.archived': '{name}의 기록은 그대로 보관돼요.',
    'pet.archiveConfirm': '{name}의 기록은 그대로 보관돼요. 알림만 멈춥니다. 언제든 다시 볼 수 있어요.',
    'pet.archiveAction': '기록 보관하기',
    'pet.errorNameRequired': '이름을 입력해 주세요.',
    'pet.errorNameTooLong': '20자까지 입력할 수 있어요.',
    'pet.errorFutureDate': '오늘보다 뒤의 날짜는 고를 수 없어요.',
    // ─── 오늘 (홈) ─────────────────────────────────────────
    'today.title': '오늘',
    'today.empty.noPet': '아이를 등록하면 오늘부터 기록할 수 있어요.',
    'today.empty.noTreatment': '오늘 예정된 투약이 없어요.',
    'today.allDone': '오늘 할 기록을 마쳤어요.',
    'today.doneCount': '{count}건 기록됨',
    'today.record': '기록',
    'today.nextVisit': '다음 진료까지 {days}일',
    'today.recordedBy': '{name}이(가) 기록',
    'today.suggestionsTitle': '아이에게 맞는 기록',
    'today.suggestionsHint': '질환 태그를 바탕으로 기록 항목을 제안해요. 필요한 것만 골라 남겨 주세요.',
    'today.quickFactTitle': '오늘 본 사실 한 줄',
    'today.quickFactHint': '별도 화면 없이 적으면 사건 기록과 진료 리포트에 함께 남아요.',
    'today.quickFactPlaceholder': '예: 저녁 산책 뒤 한 번 기침함',
    'today.quickFactSave': '한 줄 기록',
    'today.quickFactSaved': '한 줄을 기록했어요.',
    'today.quickFactUndo': '방금 기록 취소',
    'today.quickFactUndone': '방금 기록을 취소했어요.',
    // ─── 투약·처치 (F2) ────────────────────────────────────
    'treatment.new': '투약·처치 추가',
    'treatment.name': '약·처치 이름',
    'treatment.namePlaceholder': '예: 피모벤단',
    'treatment.dose': '용량',
    'treatment.dosePlaceholder': '예: 1/2정, 2.5ml',
    'treatment.doseHint': '주치의가 알려준 대로 적어 주세요.',
    'treatment.schedule': '언제 주나요',
    'treatment.daily': '매일',
    'treatment.weekly': '요일마다',
    'treatment.interval': '며칠 간격',
    'treatment.asNeeded': '필요할 때만',
    'treatment.times': '시각',
    'treatment.group': '묶어서 한 번에',
    'treatment.groupHint': "'아침 약'처럼 여러 개를 묶으면 한 번에 기록할 수 있어요.",
    'treatment.statusGiven': '줬어요',
    'treatment.statusSkipped': '건너뛰었어요',
    'treatment.statusRefused': '거부했어요',
    'treatment.statusPartial': '일부만 줬어요',
    'treatment.errorNameRequired': '약 이름을 입력해 주세요.',
    'treatment.errorTimeRequired': '시각을 골라 주세요.',
    'treatment.adherence': '{given}/{expected}회 기록',
    'treatment.payloadVolume': '용량(ml)',
    'treatment.payloadSite': '기록한 부위',
    'treatment.payloadUnits': '단위',
    'treatment.payloadGlucose': '혈당(선택)',
    'treatment.payloadHint': '지난 기록을 사실 그대로 남겨요. 다음 부위를 안내하지 않아요.',
    'treatment.lastSite': '지난 기록: {site}',
    // ─── 수면 호흡수 SRR (F5) ──────────────────────────────
    'srr.title': '수면 호흡수',
    'srr.intro': '아이가 자는 동안 가슴이 오르내릴 때마다 화면을 눌러 주세요.',
    'srr.mode15': '15초',
    'srr.mode30': '30초',
    'srr.mode60': '60초',
    'srr.tapHere': '여기를 누르세요',
    'srr.stop': '그만 세기',
    'srr.result': '분당 {rate}회',
    'srr.tooShort': '조금 더 세어 주세요. 10초 이상 필요해요.',
    'srr.noTaps': '아직 세지 않았어요.',
    'srr.outOfRange': '값을 다시 확인해 주세요.',
    'srr.overThreshold': '주치의가 정한 기준({value}회)을 넘었어요. 주치의에게 알려주세요.',
    'srr.again': '다시 세기',
    'srr.empty': '아직 호흡수 기록이 없어요.',
    // ─── 기침 (F15) ────────────────────────────────────────
    'cough.title': '기침',
    'cough.tapToCount': '기침할 때마다 눌러 주세요',
    'cough.empty': '오늘 기침이 없으면 그대로 두세요.',
    'cough.undo': '한 번 취소했어요.',
    'cough.slotNight': '야간',
    'cough.slotDay': '주간',
    'cough.split': '주간 {day} · 야간 {night}',
    'cough.dailyAvg': '하루 평균 {avg}회',
    'cough.halfCompare': '앞 절반 {first}회 · 뒤 절반 {second}회',
    'cough.videoHint': '15초까지 영상을 남겨두면 진료 때 보여드릴 수 있어요.',
    // ─── 보행·산책 (F16·F21) ───────────────────────────────
    'gait.title': '보행·산책',
    'gait.tabWalk': '산책 기록',
    'gait.tabLimp': '보행 이상',
    'gait.duration': '걸은 시간',
    'gait.distance': '거리',
    'gait.walkStopped': '중간에 멈췄어요',
    'gait.limbRequired': "어느 다리인지 골라 주세요. 모르겠으면 '모르겠어요'를 선택해도 돼요.",
    'gait.limbFrontLeft': '앞 왼쪽',
    'gait.limbFrontRight': '앞 오른쪽',
    'gait.limbHindLeft': '뒤 왼쪽',
    'gait.limbHindRight': '뒤 오른쪽',
    'gait.limbUnknown': '모르겠어요',
    'gait.riseDifficulty': '일어나기 힘들어함',
    'gait.stairAvoidance': '계단을 피함',
    'gait.quickLimp': '지금 절뚝여요',
    'gait.empty': '아직 산책 기록이 없어요.',
    // ─── 호흡기 사건 (F17) ─────────────────────────────────
    'resp.title': '호흡기',
    'resp.reverseSneeze': '역재채기',
    'resp.honkingCough': '거위 울음 같은 기침',
    'resp.respiratoryDistress': '숨쉬기 힘들어함',
    'resp.timerStart': '시간 재기',
    'resp.timerRunning': '재는 중이에요.',
    'resp.timerStop': '멈추기',
    'resp.timerSaved': '{sec}초로 기록했어요.',
    'resp.empty': '아직 기록이 없어요.',
    // ─── 컨디션 (F4) ───────────────────────────────────────
    'checkin.title': '오늘 컨디션',
    'checkin.appetite': '식욕',
    'checkin.energy': '활력',
    'checkin.discomfort': '불편함',
    'checkin.elimination': '배변',
    'checkin.sleep': '수면',
    'checkin.good': '좋음',
    'checkin.usual': '평소와 같음',
    'checkin.notGood': '좋지 않음',
    'checkin.skipHint': '모르는 항목은 비워둬도 괜찮아요.',
    'checkin.notGoodDays': '{count}일 기록',
    // ─── 체중 (F6) ─────────────────────────────────────────
    'weight.title': '체중',
    'weight.value': '몸무게',
    'weight.delta': '{delta}kg ({pct}%)',
    'weight.empty': '아직 체중 기록이 없어요.',
    'weight.errorRange': '값을 다시 확인해 주세요.',
    // ─── 검사 (F18) ────────────────────────────────────────
    'lab.title': '검사 결과',
    'lab.new': '검사 결과 추가',
    'lab.testedAt': '검사일',
    'lab.clinic': '병원',
    'lab.panel': '검사 종류',
    'lab.item': '항목',
    'lab.value': '수치',
    'lab.unit': '단위',
    'lab.refRange': '참조범위',
    'lab.refHint': '검사지에 적힌 참조범위를 그대로 입력해 주세요. 병원마다 달라요.',
    'lab.refDisplay': '(참조 {low}~{high})',
    'lab.photoLabel': '검사지 사진',
    'lab.empty': '아직 검사 기록이 없어요. 검사지를 보고 입력하거나 사진으로 남겨두세요.',
    'lab.mixedUnits': '단위가 다른 결과가 섞여 있어요. 항목을 나눠서 봐 주세요.',
    'lab.trendEmpty': '이 항목은 아직 기록이 하나뿐이에요.',
    // ─── 급식·섭취량 (F19) ─────────────────────────────────
    'meal.title': '식사·물',
    'meal.serve': '급여',
    'meal.foodName': '사료·간식',
    'meal.served': '담은 양',
    'meal.leftover': '남긴 양',
    'meal.eaten': '먹은 양',
    'meal.bowlMode': '그릇째 재기',
    'meal.bowlWeight': '그릇 무게',
    'meal.pending': '섭취량 미입력',
    'meal.enterLeftover': '남긴 양 입력',
    'meal.water': '물',
    'meal.derivedWater': '습식 사료 기준 추정치로 음수량에 {ml}ml를 더했어요. 설정에서 비율을 바꿀 수 있어요.',
    'meal.leftoverExceeds': '남긴 양이 담은 양보다 많아요. 값을 다시 확인해 주세요.',
    'meal.empty': '아직 식사 기록이 없어요.',
    // ─── 사건 (F7) ─────────────────────────────────────────
    'event.title': '증상·사건',
    'event.type': '무슨 일이 있었나요',
    'event.occurredAt': '언제',
    'event.note': '메모',
    'event.durationSec': '지속 시간',
    'event.attach': '사진·영상 첨부',
    'event.empty': '아직 기록이 없어요.',
    'event.firstOccurred': '{date}부터 기록됨',
    // ─── 병원 (F8) ─────────────────────────────────────────
    'visit.title': '병원 기록',
    'visit.new': '진료 기록 추가',
    'visit.visitedAt': '방문일',
    'visit.clinic': '병원 이름',
    'visit.reason': '무엇 때문에 갔나요',
    'visit.cost': '진료비',
    'visit.nextVisit': '다음 예약일',
    'visit.attach': '처방전·검사지 사진',
    'visit.empty': '아직 병원 기록이 없어요.',
    'visit.errorCost': '금액을 다시 확인해 주세요.',
    // ─── 관리 계획·질문 (F26 · PET-EXP-26) ─────────────────
    'carePlan.title': '관리 계획과 질문',
    'carePlan.entryTitle': '병원에서 받은 계획 정리하기',
    'carePlan.entryBody': '계획을 적어 두면 다음 방문 때 물어볼 것이 모여요.',
    'carePlan.lede': '병원에서 들은 계획과 집에서 생긴 질문을 한곳에 모아요. 여기 적힌 것은 모두 보호자가 직접 남긴 내용이에요.',
    'carePlan.planSection': '관리 계획',
    'carePlan.planNew': '계획 추가',
    'carePlan.planTitle': '어떤 계획인가요',
    'carePlan.planSource': '어디서 들었나요',
    'carePlan.planSourceHint': '병원 이름이나 수의사 선생님 성함을 적어 두면 나중에 출처를 알 수 있어요.',
    'carePlan.planCheckedOn': '들은 날',
    'carePlan.planValidUntil': '언제까지 (선택)',
    'carePlan.planRecheckOn': '다시 확인할 날 (선택)',
    'carePlan.planEmpty': '아직 적어 둔 계획이 없어요.',
    'carePlan.stateActive': '진행 중',
    'carePlan.stateOpenEnded': '기간 미정',
    'carePlan.stateRecheck': '다시 확인할 때가 됐어요',
    'carePlan.stateExpired': '기간이 지났어요',
    'carePlan.attention': '다시 확인할 계획 {count}건',
    'carePlan.questionSection': '다음에 물어볼 것',
    'carePlan.questionNew': '질문 추가',
    'carePlan.questionText': '무엇을 물어볼까요',
    'carePlan.questionEmpty': '아직 적어 둔 질문이 없어요.',
    'carePlan.questionCarried': '방문 {count}번을 넘겼어요',
    'carePlan.answeredSection': '답을 받은 질문',
    'carePlan.answerLabel': '들은 답',
    'carePlan.groupSection': '이어진 기록 묶음',
    'carePlan.groupNew': '묶음 만들기',
    'carePlan.groupTitle': '무엇에 대한 묶음인가요',
    'carePlan.groupDates': '해당한 날짜',
    'carePlan.groupDatesHint': '쉼표로 나눠 적어요. 예: 2026-08-01, 2026-08-03',
    'carePlan.groupSpan': '{start} ~ {end} · {days}일',
    'carePlan.groupEmpty': '아직 묶어 둔 기록이 없어요.',
    'carePlan.closeSection': '방문 뒤 답 적기',
    'carePlan.closeVisitedOn': '방문한 날',
    'carePlan.closeSave': '답 저장',
    'carePlan.closeHint': '답을 적은 질문만 닫혀요. 답을 못 받은 질문은 그대로 남아 다음 방문으로 넘어가요.',
    'carePlan.nothingToBring': '아직 가져갈 것이 없어요. 계획이나 질문을 적어 두면 여기 모여요.',
    'carePlan.thresholdSection': '주치의가 알려준 기준값',
    'carePlan.thresholdHint': '진료 때 들은 기준값을 그대로 적어요. 우리가 기준을 만들지 않고, 화면은 이 값이 어디서 왔는지만 보여줘요.',
    'carePlan.thresholdNew': '기준값 추가',
    'carePlan.thresholdValue': '기준 숫자',
    'carePlan.thresholdDirection': '어느 쪽일 때 알려 드릴까요',
    'carePlan.thresholdAbove': '이 값보다 높을 때',
    'carePlan.thresholdBelow': '이 값보다 낮을 때',
    'carePlan.thresholdEmpty': '아직 적어 둔 기준값이 없어요.',
    'carePlan.thresholdSetAt': '{date}에 적음',
    'carePlan.supplySection': '약·처방식·소모품 재고',
    'carePlan.supplyNew': '재고 추가',
    'carePlan.supplyName': '무엇을 세었나요',
    'carePlan.supplyRemaining': '남은 수량',
    'carePlan.supplyUnit': '단위',
    'carePlan.supplyCheckedOn': '직접 확인한 날',
    'carePlan.supplyThreshold': '내가 다시 확인할 수량 (선택)',
    'carePlan.supplyHint': '남은 수량과 확인선은 보호자가 직접 적어요. 사용량이나 구매 시점을 자동으로 추정하지 않아요.',
    'carePlan.supplyEmpty': '아직 직접 세어 둔 재고가 없어요.',
    'carePlan.supplyAttention': '내가 정한 확인선에 닿았어요',
    'carePlan.supplyCounted': '직접 센 수량',
    'carePlan.supplyRecount': '수량 다시 세기',
    'carePlan.supplyRemove': '목록에서 지우기',
    'carePlan.preparationSection': '병원·돌봄 준비 묶음',
    'carePlan.preparationHint': '관리 계획, 열린 질문, 이어진 기록과 재고를 보호자 입력 사실로 한 번에 옮겨요.',
    'carePlan.preparationCopy': '준비 묶음 복사',
    'carePlan.preparationDownload': '텍스트로 저장',
    'carePlan.preparationCopied': '준비 묶음을 복사했어요.',
    'carePlan.disclaimer': '이 화면은 보호자가 남긴 기록을 모아 보여줄 뿐이고 진단이나 치료를 대신하지 않습니다.',
    // ─── 캘린더·루틴 (F20) ─────────────────────────────────
    'calendar.title': '일정',
    'calendar.routineBrush': '양치',
    'calendar.routineEar': '귀 청소',
    'calendar.routineNail': '발톱',
    'calendar.routineDeworm': '구충',
    'calendar.routineHeartworm': '심장사상충',
    'calendar.routineVaccine': '예방접종',
    'calendar.missed': '지난 일정',
    'calendar.due': '예정',
    'calendar.done': '완료',
    'calendar.empty': '아직 등록한 일정이 없어요.',
    // ─── 삶의 질 (F13) ─────────────────────────────────────
    'qol.title': '삶의 질 기록',
    'qol.intro': '7가지를 0~10으로 남겨두면 주치의와 이야기할 때 도움이 돼요.',
    'qol.hurt': '통증',
    'qol.hunger': '식사',
    'qol.hydration': '수분',
    'qol.hygiene': '위생',
    'qol.happiness': '기분',
    'qol.mobility': '움직임',
    'qol.moreGoodDays': '좋은 날이 더 많은가',
    'qol.total': '합계 {score}',
    'qol.empty': '아직 기록이 없어요.',
    // ─── 비용 (F22) ────────────────────────────────────────
    'cost.title': '지출',
    'cost.categoryVisit': '진료비',
    'cost.categoryMed': '약값',
    'cost.categoryFood': '사료비',
    'cost.categoryInsurance': '보험료',
    'cost.categoryEtc': '기타',
    'cost.monthTotal': '{month} 합계 {amount}원',
    'cost.empty': '아직 기록된 지출이 없어요.',
    // ─── 리포트 (F9) ───────────────────────────────────────
    'report.title': '진료 리포트',
    'report.rangeMonth1': '최근 1개월',
    'report.rangeMonth3': '최근 3개월',
    'report.sinceLastVisit': '지난 진료 이후',
    'report.rangeCustom': '직접 고르기',
    'report.templateHeart': '심장',
    'report.templateKidney': '신장',
    'report.templateDiabetes': '당뇨',
    'report.templateJoint': '관절',
    'report.templateCognitive': '인지',
    'report.templateAll': '전체',
    'report.savePdf': 'PDF로 저장',
    'report.share': '공유',
    'report.done': '3개월 기록을 한 장에 담았어요.',
    'report.empty': '이 기간에는 기록이 없어요.',
    'report.generating': '리포트를 만드는 중이에요.',
    'report.blockEmpty': '기록 없음',
    'report.templateHint': '기본 항목이에요. 필요한 항목을 골라서 함께 저장해요.',
    'report.thresholdLabel': '주치의 기준 {value}회',
    'report.footerNote': '이 기록은 보호자가 집에서 관찰한 내용입니다. 진단이나 판정이 아닙니다.',
    // ─── 공동 보호자 (F10) ─────────────────────────────────
    'share.title': '함께 돌보기',
    'share.invite': '초대 링크 만들기',
    'share.invited': '초대 링크를 만들었어요. 이 링크는 다시 볼 수 없어요.',
    'share.copyLink': '링크 복사',
    'share.serverUnavailable': '공유를 준비하려면 연결이 필요해요. 기록은 기기에 남아 있어요.',
    'share.accepted': '함께 볼 준비를 했어요. 기록은 기기에 남아 있어요.',
    'share.members': '함께 보는 사람',
    'share.sync': '기록 동기화',
    'share.synced': '기록 {count}건을 반영했어요.',
    'share.revoke': '접근 취소',
    'share.revoked': '접근을 취소했어요.',
    'share.expired': '초대 링크가 만료됐어요. 다시 요청해 주세요.',
    'share.revokedNotice': '초대가 취소됐어요.',
    'share.acceptTitle': '{name}의 기록을 함께 봐요',
    'share.accept': '함께 보기',
    'share.openRecords': '기록 보기',
    'share.empty': '아직 함께 보는 사람이 없어요.',
    'share.myLabel': '내 표시 이름',
    'share.myLabelHint': '가족에게 보일 이름이에요. 예: 엄마, 아빠',
    // ─── 돌봄 교대 인계 (PET-EXP-01) ──────────────────────
    'handoff.title': '오늘 돌봄 인계',
    'handoff.intro': '다음 보호자가 바로 이어볼 기록만 직접 골라 건네요.',
    'handoff.entryTitle': '다음 보호자에게 인계하기',
    'handoff.entryBody': '완료한 돌봄과 남은 일만 짧게 묶어요.',
    'handoff.privacyTitle': '고른 내용만 기기에서 만들어요.',
    'handoff.privacyBody': '수신자 정보는 저장하지 않고, 인계 내용은 서버에 평문으로 보내지 않아요.',
    'handoff.completed': '완료된 돌봄',
    'handoff.remaining': '남은 돌봄',
    'handoff.note': '직접 남길 메모 (선택)',
    'handoff.notePlaceholder': '예: 사료는 냉장고 둘째 칸에 있어요.',
    'handoff.expiry': '다시 확인할 시각',
    'handoff.selectionHint': '불러온 항목이 먼저 선택돼요. 공유하지 않을 항목은 해제하고 미리보기를 확인해 주세요.',
    'handoff.preview': '인계 미리보기',
    'handoff.share': '공유하기',
    'handoff.download': '텍스트 저장',
    'handoff.shared': '인계를 공유했어요. 수신자는 저장하지 않았어요.',
    'handoff.copied': '인계 내용을 복사했어요.',
    'handoff.downloaded': '인계 텍스트를 기기에 저장했어요.',
    'handoff.shareFailed': '공유하지 못했어요. 선택한 내용은 그대로 있어요.',
    'handoff.selectEmpty': '인계할 기록을 골라 주세요.',
    'handoff.empty': '오늘 인계할 일정이 아직 없어요.',
    'handoff.emptyHint': '투약·처치나 케어 루틴을 만들면 완료와 남은 일을 여기서 고를 수 있어요.',
    'handoff.history': '최근 인계 이력',
    'handoff.historyEmpty': '아직 공유하거나 저장한 인계가 없어요.',
    // ─── 알림 (F3) ─────────────────────────────────────────
    'notify.ask': '약 시간에 알려드릴까요? 언제든 설정에서 끌 수 있어요.',
    'notify.unavailable': '알림 발송 연결을 준비하고 있어요. 기록 기능은 그대로 쓸 수 있어요.',
    'notify.allow': '알림 받기',
    'notify.title': '알림',
    'notify.times': '알림 시각',
    'notify.test': '테스트 발송',
    'notify.testSent': '테스트 알림을 보냈어요.',
    'notify.unsubscribe': '알림 끄기',
    'notify.unsubscribed': '알림을 껐어요.',
    'notify.empty': '등록한 알림 시각이 없어요.',
    'notify.time': '알림 시각',
    'notify.addTime': '시각 추가',
    'notify.remove': '지우기',
    'notify.slotSaved': '알림 시각을 저장했어요.',
    'notify.iosInstallTitle': '홈 화면에 추가해 주세요',
    'notify.iosInstallBody': 'iPhone에서는 홈 화면에 추가해야 알림을 받을 수 있어요. 공유 버튼을 누르고 "홈 화면에 추가"를 선택해 주세요.',
    'notify.blocked': '알림이 꺼져 있어요. 기기 설정에서 켤 수 있어요.',
    // ─── 데이터 안전 (F11) ─────────────────────────────────
    'data.title': '데이터',
    'data.backup': '백업',
    'data.backupLocal': '기기 안 자동 백업',
    'data.backupCloud': '온라인 백업',
    'data.backupLastAt': '마지막 백업 {at}',
    'data.passphrase': '복구 문구',
    'data.warnPassphrase': '복구 문구를 잃으면 온라인 백업을 복원할 수 없어요.',
    'data.export': '전체 기록 백업',
    'data.exportHint': '언제든 무료로 전체 기록을 백업할 수 있어요.',
    'data.exportCsv': '진료용 표 저장',
    'data.exportJson': '전체 기록 백업',
    'data.exported': '기록 백업을 저장했어요.',
    'data.import': '백업 복원',
    'data.importMapping': '어느 칸이 무엇인지 골라 주세요',
    'data.importResult': '{ok}건을 복원했어요. {skipped}건은 건너뛰었어요.',
    'data.importUndo': '방금 복원 되돌리기',
    'data.trash': '휴지통',
    'data.trashHint': '7일 안에는 되돌릴 수 있어요.',
    'data.trashEmpty': '휴지통이 비어 있어요.',
    'data.restore': '복원',
    'data.restored': '되돌렸어요.',
    'data.deleted': '모든 기록을 삭제했어요.',
    'data.deleteAll': '모든 데이터 삭제',
    'data.deleteAllConfirm1': '모든 기록이 사라져요. 삭제하기 전에 전체 기록 백업을 권해드려요.',
    'data.deleteAllConfirm2': '정말 삭제할까요? 되돌릴 수 없어요.',
    'data.backupTooLarge': '백업이 너무 커요. 첨부 사진을 정리해 주세요.',
    // ─── 휴지통·삭제 ───────────────────────────────────────
    'trash.confirm': '이 기록을 휴지통으로 옮길까요? 7일 안에는 되돌릴 수 있어요.',
    'trash.moved': '휴지통으로 옮겼어요.',
    // ─── 설정 ──────────────────────────────────────────────
    'settings.title': '설정',
    'settings.sound': '효과음',
    'settings.haptic': '진동',
    'settings.theme': '화면',
    'settings.themeLight': '밝게',
    'settings.themeDark': '어둡게',
    'settings.themeSystem': '기기 설정 따르기',
    'settings.about': '정보',
    'settings.version': '버전 {version}',
    'settings.changelog': '변경 이력',
    'settings.privacy': '개인정보 처리방침',
    'settings.terms': '이용약관',
    'settings.support': '문의하기',
    'settings.share': '공동 보호자 공유',
    'settings.supportSla': '영업일 기준 2일 안에 답변드려요.',
    // ─── 추모 (F24) ────────────────────────────────────────
    'memorial.title': '함께한 기록',
    'memorial.daysTogether': '{name}와 함께 기록한 날 {days}일',
    'memorial.open': '기록 보기',
    'memorial.empty': '보관된 기록이 없어요.',
    'memorial.note': '알림은 멈췄지만 기록은 그대로 남아 있어요.',
    // ─── 위젯 (F23) ────────────────────────────────────────
    'widget.doseTitle': '오늘 투약',
    'widget.doseDone': '기록했어요',
    'widget.doseEmpty': '오늘 예정된 투약이 없어요',
    'widget.srrTitle': '수면 호흡수',
    'widget.srrLast': '최근 {rate}회',
    'widget.srrMeasure': '재기',
    'widget.trendTitle': '최근 30일',
    // ─── 누적 (동기 설계) ──────────────────────────────────
    'streak.daysRecorded': '{name}와 함께 기록한 날 {days}일',
    // ─── 재진 타임라인 (TR-W1-PET-01) ────────────────────
    'timeline.entryTitle': '재진 타임라인',
    'timeline.entryBody': '고른 돌봄 사실을 날짜순으로 다시 봐요.',
    'timeline.title': '돌봄 사실을 시간 순서로 모아요.',
    'timeline.intro': '오늘·최근 7일·지난 재진 이후 기록에서 가져갈 장면과 사실을 직접 골라요.',
    'timeline.trustTitle': '사진은 보이는 그대로만 씁니다.',
    'timeline.trustBody': '사진의 내용으로 건강 상태나 몸의 변화를 해석하지 않아요. 얼굴·품종 인식도 하지 않고, 선택하지 않은 기록은 공유하거나 내보내지 않아요.',
    'timeline.permission': '새 카메라·사진 권한을 요청하지 않아요. 기기에 이미 붙여 둔 사진만 이 화면에서 불러옵니다.',
    'timeline.empty': '이 기간에 모을 돌봄 사실이 없어요.',
    'timeline.emptyHint': '투약·식사·활동·사건 기록을 남기면 사진 없이도 사실 카드가 생겨요.',
    'timeline.recap': '한 장씩 회고',
    'timeline.manualOnly': '자동 재생하지 않아요. 이전·다음을 직접 눌러 순서대로 확인해요.',
    'timeline.selectEmpty': '아직 고른 기록이 없어요.',
    'timeline.selectHint': '포함할 사실을 직접 고르면 회고와 내보내기가 열려요.',
    'timeline.share': '고른 사실 공유',
    'timeline.download': '고른 사실 저장',
    'timeline.shared': '고른 사실만 공유했어요.',
    'timeline.copied': '고른 사실만 복사했어요.',
    'timeline.downloaded': '고른 사실만 기기에 저장했어요.',
    'timeline.shareFailed': '공유하지 못했어요. 선택한 기록은 그대로 있어요.',
    'caresheet.title': '오늘 기록지',
    'caresheet.guardian': '보호자',
    'caresheet.notYet': '아직',
    'caresheet.recorded': '남긴 칸',
    'caresheet.emergency': '응급',
    'caresheet.share': '가족·시터·병원에 건네기',
    'caresheet.morningMedicine': '아침 약',
    'caresheet.eveningMedicine': '저녁 약',
    'caresheet.medicine': '약·처치',
    'caresheet.given': '줬어요',
    'caresheet.actualAmount': '실제 용량 남기기',
    'caresheet.actualAmountHint': '실제로 한 용량과 시각을 남겨요',
    'caresheet.nightRate': '밤 호흡수',
    'caresheet.perMinute': '회/분',
    'caresheet.count': '세기',
    'caresheet.cough': '기침',
    'caresheet.day': '낮',
    'caresheet.night': '밤',
    'caresheet.observedCount': '회 직접 봄',
    'caresheet.coughPeriod': '기침 관찰 시간대',
    'caresheet.dayObservation': '낮 관찰',
    'caresheet.nightObservation': '밤 관찰',
    'caresheet.compareOriginals': '원본 비교하기',
    'caresheet.none': '없었어요',
    'caresheet.happened': '있었어요',
    'caresheet.water': '물',
    'caresheet.urine': '소변',
    'caresheet.walk': '산책·보행',
    'caresheet.limb': '어느 다리',
    'caresheet.rise': '일어서기',
    'caresheet.resp': '호흡기 사건',
    'caresheet.glucose': '혈당',
    'caresheet.insulin': '인슐린',
    'caresheet.meal': '식사',
    'caresheet.seizure': '발작 시간',
    'caresheet.record': '남기기',
    'caresheet.viewRecord': '원본 보기',
    'caresheet.note': '한 줄',
    'caresheet.notePlaceholder': '예: 산책 뒤 한 번 켁켁함',
    'caresheet.saveNote': '한 줄 남기기',
    'caresheet.other': '다른 기록',
    'caresheet.otherTitle': '다른 기록 남기기',
    'caresheet.quiet': '오늘 별일 없었어요',
    'caresheet.quietUndo': '별일 없음 · 되돌리기',
    'caresheet.nextVisit': '다음 진료',
    'caresheet.openBrief': '진료 첫 장 미리 보기',
    'caresheet.addMedicine': '+ 약 시간 등록하기',
    'caresheet.changeColumns': '지켜보는 것 바꾸기',
    'caresheet.allTools': '모든 기록·돌봄 도구 열기',
    'caresheet.shareTitle': '누구에게 건넬까요?',
    'caresheet.careSheet': '맡길 때 한 장',
    'caresheet.handoff': '돌봄 교대 인계',
    'caresheet.pdf': 'PDF 리포트',
    'caresheet.family': '가족과 같은 기록',
    'caresheet.flow': '기록의 흐름',
    'caresheet.flowHint': '의 원본을 날짜와 기간으로 살펴봐요.',
    'caresheet.history': '전체 기록',
    'caresheet.calendar': '달력',
    'caresheet.summary': '주간·월간 요약',
    'caresheet.changes': '바뀐 점 연표',
    'caresheet.days': '하루씩 돌아보기',
    'caresheet.moreTools': '오늘 남긴 것·돌봄 도구',
    'caresheet.draftError': '초안을 보관하지 못했어요. 화면을 떠나기 전에 저장해 주세요.',
    'caresheet.inputKept': '입력은 남아 있어요.',
    'onboarding.title': '아이 등록',
    'onboarding.steps': '등록 순서',
    'onboarding.skip': '건너뛰기',
    'onboarding.petTitle': '어떤 아이와 함께하나요?',
    'onboarding.petHint': '이름 한 칸만 적으면 시작할 수 있어요.',
    'onboarding.watchTitle': '주치의와 함께 지켜보는 게 있나요?',
    'onboarding.watchHint': '고르면 오늘 기록지에 그 칸이 생겨요. 진단을 뜻하지 않아요.',
    'onboarding.medicineTitle': '약을 주는 시간이 있나요?',
    'onboarding.medicineHint': '보호자가 정한 시간만 기록해요. 나중에 추가해도 돼요.',
    'onboarding.name': '아이 이름 · 필수',
    'onboarding.nameRequired': '아이 이름을 먼저 적어 주세요.',
    'onboarding.none': '아직 없어요',
    'onboarding.noteOnly': '한 줄 기록만 써요',
    'onboarding.preview': '생길 칸 미리보기',
    'onboarding.medicineName': '약 이름 · 선택',
    'onboarding.medicineTimes': '매일 주는 시각 · 선택',
    'onboarding.timeHint': '24시간 시각을 쉼표로 나눠 적어요. 용량과 알림은 나중에 따로 설정해요.',
    'onboarding.timeError': '시각을 08:00, 20:00처럼 적어 주세요. 입력은 그대로예요.',
    'onboarding.finish': '오늘 기록지 열기',
    'onboarding.quick': '이름 + 한 줄로 빠르게 시작',
    'night.title': '밤 호흡수 세기',
    'night.history': '지난 14밤',
    'night.missingHint': '빈 칸은 아직 재지 않은 밤이에요.',
    'night.threshold': '주치의 기준 {value}회 · 보호자 입력',
    'night.noThreshold': '주치의 기준을 입력하지 않았어요.',
    'night.originals': '날짜별 원본 숫자 보기',
    'night.tapHint': '가슴이 한 번 오르내릴 때마다 눌러요.',
    'night.start': '누르면 세기 시작',
    'night.running': '화면을 눌러 한 숨씩 남겨요',
    'night.left': '{seconds}초 남음',
    'night.result': '이번에 센 숨',
    'night.unsaved': '아직 저장 전이에요.',
    'night.saved': '이 기기에 저장했어요.',
    'night.return': '오늘 기록지로',
    'night.close': '세기 닫고 오늘로',
    'night.resultCount': '{taps}번 · {seconds}초 동안 셌어요.',
    'night.interrupted': '세기를 멈췄어요. 새로 세거나 현재 결과를 확인해 주세요.',
    'night.retryLoad': '지난 기록을 불러오지 못했어요. 이번 숫자는 그대로예요.',
    'night.thresholdSettings': '주치의가 알려준 기준값 입력',
    'night.video': '찍어 둔 영상으로 세기',
    'night.live': '지금 세기',
    'night.undoTap': '한 번 되돌리기',
    'landing.careAudience': '심장·신장·관절 — 오래 돌보는 아이의 기록장',
    'landing.careTitle': '약, 밤 호흡수, 기침. 매일 30초 남기면 재진 날 한 장이 돼요.',
    'landing.careHint': '가입 없이 이 기기에 저장돼요. 건강을 판정하지 않고, 본 것만 남겨요.',
    'landing.careToolTitle': '지금 자고 있나요?',
    'landing.careToolHint': '가슴이 한 번 오르내릴 때마다 눌러 보세요.',
    'landing.careStart': '가입 없이 시작하기',
    'landing.careMechanism': '지금 남기기 → 매일 모으기 → 재진 날 한 장',
    'visit.recordedDays': '기록한 날 {recorded}/{total}일',
};
/** {변수} 치환. 값이 없으면 자리표시자를 그대로 남기지 않고 빈 문자열로 지운다. */
export function t(key, vars) {
    const raw = ko[key];
    if (!vars)
        return raw;
    return raw.replace(/\{(\w+)\}/g, (_, name) => String(vars[name] ?? ''));
}
